import { z } from "zod";

export const richTextSchema = z.string();
